import React, { Children, cloneElement, useRef, useState, useEffect } from 'react'
import cx from 'classnames'
import debounce from 'lodash/debounce'

const useSize = (ref) => {
  const [size, setSize] = useState({})

  useEffect(() => {
    const getSize = debounce(() => {
      const size = ref.current.getBoundingClientRect()

      setSize(size)
    }, 200)

    window.addEventListener('resize', getSize)

    getSize()

    return () => window.removeEventListener('resize', getSize)
  }, [])

  return [
    size,
    setSize
  ]
}

function Carousel({
  children,
  className,
  onChange,
  padding = 10
}) {
  const ref = useRef()
  const [size] = useSize(ref)
  const [index, setIndex] = useState(0)

  const { width } = size
  const cls = cx('carousel', className)
  const count = Children.count(children)
  const left = (width + padding) * index

  const handleIndexChange = (i) => {
    if (i < 0 || i >= count) return

    setIndex(i)
    onChange && onChange(i, count)
  }

  const prevCls = cx('carousel-prev', {
    disabled: index <= 0
  })
  const nextCls = cx('carousel-next', {
    disabled: index >= count - 1
  })

  return (
    <div className={cls}>
      <div className={prevCls} onClick={() => handleIndexChange(index - 1)}>
        <i className="icon-arrow"></i>
      </div>
      <div className="carousel-inner-wrap">
        <div ref={ref}>
          <div className="carousel-inner" style={{ width: count * (width + padding), transform: `translateX(-${left}px)` }}>
            {
              Children.map(children, child => cloneElement(child, {
                style: {
                  width,
                  marginRight: padding,
                  ...child.props.style
                }
              }))
            }
          </div>
        </div>
      </div>
      <div className={nextCls} onClick={() => handleIndexChange(index + 1)}>
        <i className="icon-arrow"></i>
      </div>
    </div>
  )
}

export default Carousel
